import React, { Component } from 'react'
import classNames from 'classnames'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'

import Tooltip from '../Tooltip'
import Loading from '../Loading'

import './Icon.scss'
import './IconButton.scss'

export default class Icon extends Component {
  static propTypes = {
    type: PropTypes.string,
    color: PropTypes.oneOf([
      'teal',
      'orange',
      'yellow',
      'green',
      'purple',
      'darkPink',
      'white',
      'darkerGray',
      'transparent',
      'midGray',
      'blue',
    ]),
    small: PropTypes.bool,
    medium: PropTypes.bool,
    big: PropTypes.bool,
  }

  static defaultProps = {
    type: 'default',
  }

  renderContent() {
    const {
      type,
      className,
      big,
      medium,
      small,
      color,
      disabled,
      iconStyle,
      ...props
    } = this.props

    // remove props that should not be spread on an HTML element
    delete props.tooltipTriggerClassname
    delete props.tooltipClassname

    if (iconStyle) {
      return (
        <span
          className={classNames(`icon-style-${iconStyle}`, className, {
            'icon-small': small,
            'icon-medium': medium,
            'icon-big': big,
            [`icon-${color}`]: color,
            'icon-disabled': disabled,
          })}
        >
          <span {...props} className={classNames('icon', `icon-${type}`)} />
        </span>
      )
    }

    return (
      <span
        {...props}
        className={classNames(
          'icon',
          className,
          {
            'icon-small': small,
            'icon-medium': medium,
            'icon-big': big,
            [`icon-${color}`]: color,
            'icon-disabled': disabled,
          },
          `icon-${type}`
        )}
      />
    )
  }

  render() {
    const {
      tooltip,
      small: iconSmall,
      smallTooltip,
      tooltipLink,
      tooltipClassname,
      tooltipTriggerClassname,
    } = this.props

    const small = smallTooltip ?? iconSmall

    let { placement } = this.props

    if (tooltip) {
      let text = tooltip

      if (tooltip?.text) text = tooltip.text
      if (tooltip?.placement) placement = tooltip.placement

      return (
        <Tooltip
          placement={placement}
          tooltip={text}
          small={small}
          link={tooltipLink}
          className={tooltipClassname}
          triggerClassname={tooltipTriggerClassname}
        >
          {this.renderContent()}
        </Tooltip>
      )
    }

    return this.renderContent()
  }
}

export class IconButton extends Component {
  renderContent() {
    const {
      onClick,
      large,
      small,
      orange,
      yellow,
      darkPink,
      light,
      white,
      className,
      loading,
      to,
      href,
      newTab,
      rounded,
      active,
      solid,
      muted,
      disabled,
      tooltip,
      tooltipLink,
      ...props
    } = this.props

    const IconButton = to ? Link : href ? 'a' : 'div'

    return (
      <IconButton
        className={classNames('icon-button-wrapper', className, {
          'icon-button-wrapper-large': large,
          'icon-button-wrapper-small': small,
          'icon-button-wrapper-rounded': rounded,
          'icon-button-wrapper-orange': orange,
          'icon-button-wrapper-yellow': yellow,
          'icon-button-wrapper-darkPink': darkPink,
          'icon-button-wrapper-light': light,
          'icon-button-wrapper-white': white,
          'icon-button-wrapper-loading': loading,
          'icon-button-wrapper-active': active,
          'icon-button-wrapper-solid': solid,
          'icon-button-wrapper-muted': muted && !active,
          'icon-button-wrapper-disabled': disabled,
        })}
        onClick={onClick}
        to={to}
        href={href}
        target={href && newTab ? '_blank' : null}
        rel={href ? 'noopener noreferrer' : null}
      >
        {loading ? <Loading small /> : <Icon {...props} />}
      </IconButton>
    )
  }

  render() {
    let { tooltip, placement, small, tooltipLink, modifiers } = this.props

    if (tooltip) {
      let text = tooltip
      let tooltipSmall = small

      if (tooltip?.text) text = tooltip.text
      if (tooltip?.placement) placement = tooltip.placement
      if (tooltip?.small !== undefined) tooltipSmall = tooltip.small

      return (
        <Tooltip
          placement={placement}
          tooltip={text}
          small={tooltipSmall}
          link={tooltipLink}
          modifiers={modifiers}
        >
          {this.renderContent()}
        </Tooltip>
      )
    }

    return this.renderContent()
  }
}

IconButton.defaultProps = {
  placement: 'top',
}
